import { getLocale } from '@/router/utils/getLocale'
import { computed } from 'vue'

/**
 * Reactive translation helper for API-provided multilingual objects.
 *
 * This composable exposes a reactive function `t` that returns the best-matching
 * translation for the current locale. It tracks `getLocale()` internally.
 *
 * Note:
 * - Should only be used inside the `setup()` function.
 * - `t` is a computed function — do not destructure it or call it outside of the template or computed context.
 */
export const useApiTranslations = () => {
  const locale = getLocale()

  const translateApi = (value: { [lang: string]: any }): string | null => {

    if (!locale.value) {
      console.warn('No locale set')
      return ''
    }

    if (!Object.keys(value).includes(locale.value)) {
      console.warn(`Could not find translation for: "${locale.value}" in:`, value)
      return Object.values(value)[0] ?? null
    }

    return value[locale.value]
  }

  return {
    translateApi: computed(() => translateApi) // make `translateApi` reactive to locale changes
  }
}
